import { useEffect, useState } from 'react';
import Container from '../../components/Layout/Container';
import PageTopBanner from '../../components/PageTopBanner';

import { RegulationTabs } from '../../components/Tab/Tabs';
import { fetchGet } from '../../hooks/fetch';

export default function Email() {
	const pageName = '이메일무단수집거부';
	const [tabsData, setTabsData] = useState([]);
	
		function getPage() {
			fetchGet(
				`/regulation?type=EMAIL`,
				(json) => setTabsData(json)
			)
		}
	
		useEffect(() => {
			getPage();
		}, []);

	return (
		<main id="policy-page-wrap" className="email">
			<h1 className="sr-only">{`${pageName} 페이지`}</h1>

			<PageTopBanner />

			<Container>
				<div className="page-content">
					<div style={{ marginBottom: '50px' }}>
						본 웹사이트에 게시된 이메일 주소가 전자우편 수집 프로그램이나 그 밖의 기술적 장치를
						이용하여 무단으로 수집되는 것을 거부하며, 이를 위반 시 정보통신망법에 의해 형사처벌됨을
						유념하시기 바랍니다.
					</div>
					<RegulationTabs tabsData={tabsData} className="gs-sub-tab-con line" />
				</div>
			</Container>
		</main>
	);
}
